import React, { Component } from 'react';
import { Button, Row, Col, Alert, InputGroup } from 'reactstrap'; //dennis

import { ClaimantForm } from './ClaimantForm';
import { LoadingModal } from './LoadingModal';
import { WorkOrderForm } from './WorkOrderForm';

import { FetchData, FetchFile } from './utils/DataFetch';

import AddIcon from '../images/add.png';

import { GetCookie, Timeout, openFileInNewTab } from './utils/Common';

import { ClaimantTableDefault } from './ClaimantTableDefault';
import { NewClaimantModel } from './utils/NewClaimantModel';
import { WorkOrderTableDefault } from './WorkOrderTableDefault';

export class Claimant extends Component {
  static displayName = Claimant.name;

  constructor(props) {
    super(props);
    this.state = {
      isResizing: -1,
      selectedClaimant: null,
      claimantList: [],
      clickCount: 0,
      jobList: [],
      loading: false,
      fetchingData: false,
      modal: false,
      modalWorkOrder: false,
      alert: {
        color: 'info',
        message: '',
        isOpen: false,
      },
      model: {
        EventType: 'insert',
        ClmId: null,
        RepId: null,
        ClientId: null,
        ClmLastName: '',
        ClmFirstName: '',
        ClmClaimNumber: '',
        ClmClaimNumberNoDash: '',
        ClmPhone: '',
        ClmInvoiceType: 'CLM',
        ClmInvoiceCaption: '',
        ClmLanguage: '',
        ClmNote: '',
        ClmWCABNumber: '',
        ClmInsuredParty: '',
        ClmEmployer: '',
        ClmDateOfInjury: '',
        ClmDateOfInjuryStart: null,
        ClmDateOfInjuryEnd: null,
        ClmDateOfLoss: '',
        ClmDateOfLossDate: null,
        ClmStreet: '',
        ClmCity: '',
        ClmState: '',
        ClmZip: '',
        ClmEmail: '',
        ClmSSN: '',
        ClmDOB: null,
        ClmDiagnosis: '',
        ClmGender: '',
        ClmHasAttorneyFlg: false,
        ClmAppAtty: '',
        ClmAppAttyFirm: '',
        ClmAppAttyEmail: '',
        ClmAppAttyPhone: '',
        ClmDefAtty: '',
        ClmDefAttyFirm: '',
        ClmDefAttyEmail: '',
        ClmDefAttyPhone: '',
        ClmOrderedByName: '',
        ClmHeight: '',
        ClmWeight: '',
        ClmStatus: '',
        CreateDateTime: null,
        CreatebyUserId: null,
        UpdateByUserId: null,
        UpdateDateTime: null,
        IsDeletedFlg: false,
        ClientName: '',
        ClientAbbrv: '',
        RepFirstName: '',
        RepLastName: '',
      },
      searchModel: {
        ClmId: '',
        Name: '',
        ClmClaimNumberNoDash: '',
        ClientAbbrv: '',
        Phone: '',
        Employer: '',
        Insured: '',
        SortBy: 'clmLastName',
        SortDirection: 'asc',
      },
      job: {
        EventType: 'insert',
        JobNum: 0,
        JobId: null,
        JobDateTime: null,
        JobTime: null,
        FinishTime: null,
        FinishTimeString: null,
        FollowupDate: null,
        ProvId: null,
        ProviderName: '',
        ConfCallNote: '',
        AptName: '',
        AptStreet: '',
        AptCity: '',
        AptState: '',
        AptZip: '',
        AptPhone: '',
        AptDirection: '',
        FailedFlg: false,
        CallerNote: '',
        InvoiceNote: '',
        IntCheckDate: null,
        IntCheckNum: null,
        InvoicedFlg: false,
        JobTotal: null,
        JobDiscount: null,
        IntFee: null,
        IntFeeOther: null,
        IntOTFee: null,
        IntFeeNote: '',
        TransportationFlg: false,
        TransConfFlg: false,
        IntConfFlg: false,
        AppointmentTypeId: '9e5e4810-c5a8-428b-8f7d-71422b6b77e3', // conf call
        CallerType: null,
        ProvConfFlg: false,
        ClmConfFlg: false,
        IsDeletedFlg: false,
        BillReviewedFlg: false,
        AuditFlg: false,
        PurpleReportFlg: false,
        RepAuthorizedFlg: false,
        SelectedFlg: false,
        ClmId: '',
        ClmFirstName: '',
        ClmLastName: '',
        ClmClaimNumber: '',
        ClmClaimNumberNoDash: '',
        ClmPhone: '',
        ClmDateOfLoss: '',
        ClmDateOfLossDate: null,
        ClmDateOfInjury: '',
        ClmDateOfInjuryStart: null,
        ClmDateOfInjuryEnd: null,
        ClmNote: '',
        ClmDOB: null,
        ClmInsuredParty: '',
        ClmEmployer: '',
        ClmInvoiceCaption: '',
        ClmLanguage: '',
        ClmWCABNumber: '',
        ClmInvoiceType: '',
        ClmStreet: '',
        ClmCity: '',
        ClmState: '',
        ClmZip: '',
        ClmSSN: '',
        ClmOrderedByName: '',
        ClmDiagnosis: '',
        ClmEmail: '',
        RepId: null,
        RepFirstName: '',
        RepLastName: '',
        RepPhone: '',
        RepEmail: '',
        ClientId: '',
        ClientAbbrv: '',
        ClientName: '',
        ClientStreet: '',
        ClientStreet2: '',
        ClientCity: '',
        ClientState: '',
        ClientZip: '',
        ClientMailStreet: '',
        ClientMailStreet2: '',
        ClientMailCity: '',
        ClientMailState: '',
        ClientMailZip: '',
        ClientPhone: '',
        ClientPhoneFax: '',
        ClientPhone2: '',
        ClientEmail: '',
        ClientInactiveFlg: false,
        IntId: null,
        IntLastName: '',
        IntFirstName: '',
        IntCellTxt: '',
        IntPhoneOnly: '',
        IntEmail: '',
        IntNote: '',
        InHouseFlg: false,
        IntCity: '',
        IntStreet: '',
        IntState: '',
        IntZip: '',
        DBA: '',
        Rate: 0,
        HourMinimum: 0,
        Prorate: '',
        BankRoute: '',
        BankAccount: '',
        IntSSINumber: '',
        FirstName: '',
        LastName: '',
        UserType: '',
        UserIntId: null,
        CreateDateTime: null,
        CreateByUserId: null,
        RemIntFlg: false,
        RemClaimFlg: false,
        RemProvFlg: false,
        RemFinalFlg: false,
        RemType: null,
        RemTypeDesc: '',
        RemHost: null,
        RemHostDesc: '',
        CreatedBy: '',
        UpdatedBy: '',
        MyJobTJobHistory: '',
        JobBalance: null,
      },
    };
    this.user = JSON.parse(GetCookie('user'));

    this.setModal = this.setModal.bind(this);
    this.setModalWorkOrder = this.setModalWorkOrder.bind(this);
    this.handleSaveEventSuccess = this.handleSaveEventSuccess.bind(this);
    this.handleSaveEventWorkOrderSuccess =
      this.handleSaveEventWorkOrderSuccess.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleDoubleClick = this.handleDoubleClick.bind(this);
    this.resetFields = this.resetFields.bind(this);

    this.renderClaimantTable = this.renderClaimantTable.bind(this);
    //
    this.handleSearchChange = this.handleSearchChange.bind(this);
    //
    this.handleKeyDown = this.handleKeyDown.bind(this);
    //
    this.addWorkOrder = this.addWorkOrder.bind(this);
    this.viewWorkOrder = this.viewWorkOrder.bind(this);
    //
    this.viewInvoice = this.viewInvoice.bind(this);
    //
    this.setFetchingData = this.setFetchingData.bind(this);
  }

  componentDidMount() {
    if (this.props.initialClaimNumber) {
      this.setState(
        (prevState) => ({
          searchModel: { ...prevState.searchModel, ClmClaimNumberNoDash: this.props.initialClaimNumber },
        }),
        () => this.populateClaimantData(),
      );
    }
  }

  setModal() {
    this.setState({ modal: !this.state.modal });
  }

  setModalWorkOrder() {
    this.setState({ modalWorkOrder: !this.state.modalWorkOrder });
  }

  resetFields() {
    this.setState({ model: NewClaimantModel() });

    this.setModal();
  }

  handleDoubleClick(claimantData) {
    const parseBoolean = (value, fallback) => {
      if (value === null || value === undefined || value === '') {
        return fallback;
      }
      if (typeof value === 'boolean') {
        return value;
      }
      if (typeof value === 'number') {
        return value === 1;
      }
      const normalized = String(value).trim().toLowerCase();
      if (['1', 'true', 't', 'yes', 'y'].includes(normalized)) {
        return true;
      }
      if (['0', 'false', 'f', 'no', 'n'].includes(normalized)) {
        return false;
      }
      return fallback;
    };

    let searchModel = {
      ClmId: claimantData.data.clmId,
      Name: '',
      ClmClaimNumberNoDash: '',
      ClientAbbrv: '',
      Phone: '',
      Employer: '',
      Insured: '',
      SortBy: '',
      SortDirection: '',
    };

    FetchData('/getclaimants', 'POST', this.user.token, searchModel).then(
      (data) => {
        const fallbackAttorneyRaw =
          claimantData.data.clmHasAttorneyFlg ??
          claimantData.data.ClmHasAttorneyFlg ??
          claimantData.data.clmHasAttorney ??
          claimantData.data.ClmHasAttorney;
        const source =
          Array.isArray(data) && data.length > 0 ? data[0] : claimantData.data;
        const clmHasAttorneyValue =
          source.clmHasAttorneyFlg ??
          source.ClmHasAttorneyFlg ??
          source.clmHasAttorney ??
          source.ClmHasAttorney;
        const clmHasAttorneyNormalized = parseBoolean(
          clmHasAttorneyValue,
          parseBoolean(fallbackAttorneyRaw, false),
        );

        this.setState((prevState) => ({
          alert: {
            color: 'info',
            message: '',
            isOpen: false,
          },
          model: {
            EventType: 'update',
            ClmId: source.clmId,
            RepId: source.repId,
            ClientId: source.clientId,
            ClmLastName: source.clmLastName,
            ClmFirstName: source.clmFirstName,
            ClmClaimNumber: source.clmClaimNumber,
            ClmClaimNumberNoDash: source.clmClaimNumberNoDash,
            ClmPhone: source.clmPhone,
            ClmInvoiceType: source.clmInvoiceType,
            ClmInvoiceCaption: source.clmInvoiceCaption,
            ClmLanguage: source.clmLanguage,
            ClmNote: source.clmNote,
            ClmWCABNumber: source.clmWCABNumber,
            ClmInsuredParty: source.clmInsuredParty,
            ClmEmployer: source.clmEmployer,
            ClmDateOfInjury: source.clmDateOfInjury,
            ClmDateOfInjuryStart: source.clmDateOfInjuryStart,
            ClmDateOfInjuryEnd: source.clmDateOfInjuryEnd,
            ClmDateOfLoss: source.clmDateOfLoss,
            ClmDateOfLossDate: source.clmDateOfLossDate,
            ClmStreet: source.clmStreet,
            ClmCity: source.clmCity,
            ClmState: source.clmState,
            ClmZip: source.clmZip,
            ClmEmail: source.clmEmail,
            ClmSSN: source.clmSSN,
            ClmDOB: source.clmDOB,
            ClmDiagnosis: source.clmDiagnosis,
            ClmGender: source.clmGender,
            ClmHasAttorneyFlg: clmHasAttorneyNormalized,
            ClmAppAtty: source.clmAppAtty,
            ClmAppAttyFirm: source.clmAppAttyFirm,
            ClmAppAttyEmail: source.clmAppAttyEmail,
            ClmAppAttyPhone: source.clmAppAttyPhone,
            ClmDefAtty: source.clmDefAtty,
            ClmDefAttyFirm: source.clmDefAttyFirm,
            ClmDefAttyEmail: source.clmDefAttyEmail,
            ClmDefAttyPhone: source.clmDefAttyPhone,
            ClmOrderedByName: source.clmOrderedByName,
            ClmHeight: source.clmHeight,
            ClmWeight: source.clmWeight,
            ClmStatus: source.clmStatus,
            CreateDateTime: source.createDateTime,
            CreatebyUserId: source.createbyUserId,
            UpdateByUserId: source.updateByUserId,
            UpdateDateTime: source.updateDateTime,
            IsDeletedFlg: source.isDeletedFlg,
            ClientName: source.clientName,
            ClientAbbrv: source.clientAbbrv,
            RepFirstName: source.repFirstName,
            RepLastName: source.repLastName,
          },
        }));
        this.setModal();
      },
    );
  }

  handleClick(claimantData) {
    this.setState({ clickCount: this.state.clickCount + 1 });
    this.clickTimer = setTimeout(() => {
      if (this.state.clickCount === 1) {
        this.setState({
          selectedClaimant: claimantData.data,
          fetchingData: true,
        });
        let model = {
          ClmId: claimantData.data.clmId,
        };
        FetchData('/getworkorders', 'POST', this.user.token, model).then(
          (data) => {
            this.setState({ jobList: data, fetchingData: false });
          },
        );
      }
      this.setState({ clickCount: 0 }); // reset count after action
    }, 300); // 300 ms delay
  }

  handleSaveEventSuccess(alert) {
    this.setState(
      {
        modal: alert.modal,
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
        selectedClaimant: null,
      },
      () => {
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });
        }, Timeout(alert.message));

        if (alert.model?.EventType === 'insert') {
          this.setState(
            {
              searchModel: {
                ClmId: '',
                Name: alert.model.ClmLastName,
                ClmClaimNumberNoDash: '',
                ClientAbbrv: '',
                Phone: '',
                Employer: '',
                Insured: '',
                SortBy: 'clmLastName',
                SortDirection: 'asc',
              },
            },
            () => {
              this.populateClaimantData();
            },
          );
        } else this.populateClaimantData();
      },
    );
  }

  handleSaveEventWorkOrderSuccess(alert) {
    this.setState(
      {
        modalWorkOrder: alert.modal,
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });
        }, Timeout(alert.message));
      },
    );
  }

  handleSearchChange(e) {
    let model = { ...this.state.searchModel };
    model[e.target.name] = e.target.value;

    this.setState({ searchModel: model });
  }

  handleKeyDown(e) {
    if (e.key === 'Enter') {
      this.setState({ jobList: [] });
      this.populateClaimantData();
    }
  }

  addWorkOrder(claimant) {
    this.setState((prevState) => ({
      job: {
        EventType: 'insert',
        JobNum: 0,
        JobId: null,
        JobDateTime: null,
        JobTime: null,
        FinishTime: null,
        FinishTimeString: null,
        FollowupDate: null,
        ProvId: null,
        ProviderName: '',
        ConfCallNote: '',
        AptName: '',
        AptStreet: '',
        AptCity: '',
        AptState: '',
        AptZip: '',
        AptPhone: '',
        AptDirection: '',
        FailedFlg: false,
        CallerNote: '',
        InvoiceNote: '',
        IntCheckDate: null,
        IntCheckNum: null,
        InvoicedFlg: false,
        JobTotal: null,
        JobDiscount: null,
        IntFee: null,
        IntFeeOther: null,
        IntOTFee: null,
        IntFeeNote: '',
        TransportationFlg: false,
        TransConfFlg: false,
        IntConfFlg: false,
        AppointmentTypeId: '9e5e4810-c5a8-428b-8f7d-71422b6b77e3', // conf call
        CallerType: null,
        ProvConfFlg: false,
        ClmConfFlg: false,
        IsDeletedFlg: false,
        BillReviewedFlg: false,
        AuditFlg: false,
        PurpleReportFlg: false,
        RepAuthorizedFlg: false,
        SelectedFlg: false,
        ClmId: claimant.clmId,
        ClmFirstName: claimant.clmFirstName,
        ClmLastName: claimant.clmLastName,
        ClmClaimNumber: claimant.clmClaimNumber,
        ClmClaimNumberNoDash: claimant.clmClaimNumberNoDash,
        ClmPhone: claimant.clmPhone,
        ClmDateOfLoss: claimant.clmDateOfLoss,
        ClmDateOfLossDate: claimant.clmDateOfLossDate,
        ClmDateOfInjury: claimant.clmDateOfInjury,
        ClmDateOfInjuryStart: claimant.clmDateOfInjuryStart,
        ClmDateOfInjuryEnd: claimant.clmDateOfInjuryEnd,
        ClmNote: claimant.clmNote,
        ClmDOB: claimant.clmDOB,
        ClmInsuredParty: claimant.clmInsuredParty,
        ClmEmployer: claimant.clmEmployer,
        ClmInvoiceCaption: claimant.clmInvoiceCaption,
        ClmLanguage: claimant.clmLanguage,
        ClmWCABNumber: claimant.clmWCABNumber,
        ClmInvoiceType: claimant.clmInvoiceType,
        ClmStreet: claimant.clmStreet,
        ClmCity: claimant.clmCity,
        ClmState: claimant.clmState,
        ClmZip: claimant.clmZip,
        ClmSSN: claimant.clmSSN,
        ClmOrderedByName: claimant.clmOrderedByName,
        ClmDiagnosis: claimant.clmDiagnosis,
        ClmEmail: claimant.clmEmail,
        RepId: claimant.repId,
        RepFirstName: claimant.repFirstName,
        RepLastName: claimant.repLastName,
        RepPhone: claimant.repPhone,
        RepEmail: claimant.repEmail,
        ClientId: claimant.clientId,
        ClientAbbrv: claimant.clientAbbrv,
        ClientName: claimant.clientName,
        ClientStreet: claimant.clientStreet,
        ClientStreet2: claimant.clientStreet2,
        ClientCity: claimant.clientCity,
        ClientState: claimant.clientState,
        ClientZip: claimant.clientZip,
        ClientMailStreet: claimant.clientMailStreet,
        ClientMailStreet2: claimant.clientMailStreet2,
        ClientMailCity: claimant.clientMailCity,
        ClientMailState: claimant.clientMailState,
        ClientMailZip: claimant.clientMailZip,
        ClientPhone: claimant.clientPhone,
        ClientPhoneFax: claimant.clientPhoneFax,
        ClientPhone2: claimant.clientPhone2,
        ClientEmail: claimant.clientEmail,
        ClientInactiveFlg: claimant.clientInactiveFlg,
        IntId: null,
        IntLastName: '',
        IntFirstName: '',
        IntCellTxt: '',
        IntPhoneOnly: '',
        IntEmail: '',
        IntNote: '',
        InHouseFlg: false,
        IntCity: '',
        IntStreet: '',
        IntState: '',
        IntZip: '',
        DBA: '',
        Rate: 0,
        HourMinimum: 0,
        Prorate: '',
        BankRoute: '',
        BankAccount: '',
        IntSSINumber: '',
        FirstName: '',
        LastName: '',
        UserType: '',
        UserIntId: null,
        CreateDateTime: null,
        CreateByUserId: null,
        RemIntFlg: false,
        RemClaimFlg: false,
        RemProvFlg: false,
        RemFinalFlg: false,
        RemType: null,
        RemTypeDesc: '',
        RemHost: null,
        RemHostDesc: '',
        CreatedBy: '',
        UpdatedBy: '',
        MyJobTJobHistory: '',
        JobBalance: null,
      },
    }));

    this.setModalWorkOrder();
  }

  viewWorkOrder(workOrder, showModal) {
    FetchData(
      '/getworkorder?jobId=' + workOrder.data.jobId,
      'POST',
      this.user.token,
      null,
    ).then((data) => {
      this.setState((prevState) => ({
        job: {
          EventType: 'update',
          JobNum: data.jobNum,
          JobId: data.jobId,
          JobDateTime: data.jobDateTime,
          JobTime: data.jobTime,
          FinishTime: data.finishTime,
          FinishTimeString:
            data.finishTimeString === '00:00' ? null : data.finishTimeString,
          FollowupDate: data.followupDate,
          ProvId: data.provId,
          ProviderName: data.providerName,
          ConfCallNote: data.confCallNote,
          AptName: data.aptName,
          AptStreet: data.aptStreet,
          AptCity: data.aptCity,
          AptState: data.aptState,
          AptZip: data.aptZip,
          AptPhone: data.aptPhone,
          AptDirection: data.aptDirection,
          FailedFlg: data.failedFlg,
          CallerNote: data.callerNote,
          InvoiceNote: data.invoiceNote,
          IntCheckDate: data.intCheckDate,
          IntCheckNum: data.intCheckNum,
          InvoicedFlg: data.invoicedFlg,
          JobTotal: data.jobTotal,
          JobDiscount: data.jobDiscount,
          IntFee: data.intFee === null ? null : parseInt(data.intFee),
          IntFeeOther:
            data.intFeeOther === null ? null : parseInt(data.intFeeOther),
          IntOTFee: data.intOTFee === null ? null : parseInt(data.intOTFee),
          IntFeeNote: data.intFeeNote,
          TransportationFlg: data.transportationFlg,
          TransConfFlg: data.transConfFlg,
          IntConfFlg: data.intConfFlg,
          AppointmentTypeId: data.appointmentTypeId,
          CallerType: data.callerType,
          ProvConfFlg: data.provConfFlg,
          ClmConfFlg: data.clmConfFlg,
          IsDeletedFlg: data.isDeletedFlg,
          BillReviewedFlg: data.billReviewedFlg,
          AuditFlg: data.auditFlg,
          PurpleReportFlg: data.purpleReportFlg,
          RepAuthorizedFlg: data.repAuthorizedFlg,
          SelectedFlg: data.selectedFlg,
          ClmId: data.clmId,
          ClmFirstName: data.clmFirstName,
          ClmLastName: data.clmLastName,
          ClmClaimNumber: data.clmClaimNumber,
          ClmClaimNumberNoDash: data.clmClaimNumberNoDash,
          ClmPhone: data.clmPhone,
          ClmDateOfLoss: data.clmDateOfLoss,
          ClmDateOfLossDate: data.clmDateOfLossDate,
          ClmDateOfInjury: data.clmDateOfInjury,
          ClmDateOfInjuryStart: data.clmDateOfInjuryStart,
          ClmDateOfInjuryEnd: data.clmDateOfInjuryEnd,
          ClmNote: data.clmNote,
          ClmDOB: data.clmDOB,
          ClmInsuredParty: data.clmInsuredParty,
          ClmEmployer: data.clmEmployer,
          ClmInvoiceCaption: data.clmInvoiceCaption,
          ClmLanguage: data.clmLanguage,
          ClmWCABNumber: data.clmWCABNumber,
          ClmInvoiceType: data.clmInvoiceType,
          ClmStreet: data.clmStreet,
          ClmCity: data.clmCity,
          ClmState: data.clmState,
          ClmZip: data.clmZip,
          ClmSSN: data.clmSSN,
          ClmOrderedByName: data.clmOrderedByName,
          ClmDiagnosis: data.clmDiagnosis,
          ClmEmail: data.clmEmail,
          RepId: data.repId,
          RepFirstName: data.repFirstName,
          RepLastName: data.repLastName,
          RepPhone: data.repPhone,
          RepEmail: data.repEmail,
          ClientId: data.clientId,
          ClientAbbrv: data.clientAbbrv,
          ClientName: data.clientName,
          ClientStreet: data.clientStreet,
          ClientStreet2: data.clientStreet2,
          ClientCity: data.clientCity,
          ClientState: data.clientState,
          ClientZip: data.clientZip,
          ClientMailStreet: data.clientMailStreet,
          ClientMailStreet2: data.clientMailStreet2,
          ClientMailCity: data.clientMailCity,
          ClientMailState: data.clientMailState,
          ClientMailZip: data.clientMailZip,
          ClientPhone: data.clientPhone,
          ClientPhoneFax: data.clientPhoneFax,
          ClientPhone2: data.clientPhone2,
          ClientEmail: data.clientEmail,
          ClientInactiveFlg: data.clientInactiveFlg,
          IntId: data.intId,
          IntLastName: data.intLastName,
          IntFirstName: data.intFirstName,
          IntCellTxt: data.intCellTxt,
          IntPhoneOnly: data.intPhoneOnly,
          IntEmail: data.intEmail,
          IntNote: data.intNote,
          InHouseFlg: data.inHouseFlg,
          IntCity: data.intCity,
          IntStreet: data.intStreet,
          IntState: data.intState,
          IntZip: data.intZip,
          DBA: data.dDBA,
          Rate: data.rate,
          HourMinimum: data.hourMinimum,
          Prorate: data.prorate,
          BankRoute: data.bankRoute,
          BankAccount: data.bankAccount,
          IntSSINumber: data.intSSINumber,
          FirstName: data.firstName,
          LastName: data.lastName,
          UserType: data.userType,
          UserIntId: data.userIntId,
          CreateDateTime: data.createDateTime,
          CreateByUserId: data.createByUserId,
          UpdateDateTime: data.updateDateTime,
          UpdateByUserId: data.updateByUserId,
          RemIntFlg: data.remIntFlg,
          RemClaimFlg: data.remClaimFlg,
          RemProvFlg: data.remProvFlg,
          RemFinalFlg: data.remFinalFlg,
          RemType: data.remType,
          RemTypeDesc: data.remTypeDesc,
          RemHost: data.remHost,
          RemHostDesc: data.remHostDesc,
          CreatedBy: data.createdBy,
          UpdatedBy: data.updatedBy,
          MyJobTJobHistory: data.myJobTJobHistory,
          JobBalance: data.jobBalance,
          WorkFlowId: data.workFlowId,
        },
        modalWorkOrder: showModal,
      }));
    });
  }

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.setState({ gridApiReady: true });
    this.autoSizeUnspecifiedColumns(false);
  };

  onDataLoaded = (newData) => {
    this.gridApi.setRowData(newData);
    this.autoSizeUnspecifiedColumns(true);
  };

  onColumnResized = (params) => {
    if (params.finished) {
      // Update the state with new column width
      const newWidths = { ...this.state.columnWidths };
      params.columns.forEach((column) => {
        newWidths[column.getColId()] = column.getActualWidth();
      });
      this.setState({ columnWidths: newWidths });
    }
  };

  autoSizeUnspecifiedColumns = () => {
    const allColumnIds = [];
    this.gridColumnApi.getAllColumns().forEach((column) => {
      // Check if the width is not set in the column definition
      if (column.getColDef().width === undefined) {
        allColumnIds.push(column.colId);
      }
    });
    if (allColumnIds.length > 0) {
      this.gridColumnApi.autoSizeColumns(allColumnIds, false);
    }
  };

  viewInvoice(e, woData, i) {
    e.preventDefault();

    let body = {
      JobId: '',
    };

    body.JobId = woData.jobId;
    let currentDate = new Date();
    let invoiceFileName =
      'Invoice ' +
      woData.jobNum +
      ' ' +
      (currentDate.getMonth() + 1) +
      '-' +
      (currentDate.getDate() + 1) +
      '-' +
      currentDate.getFullYear() +
      '.pdf';

    FetchFile('/printinvoices', 'POST', this.user.token, body).then((blob) => {
      if (!blob || blob.size === 0) {
        this.setState(
          { alert: { color: 'warning', message: 'No file returned.', isOpen: true } },
          () => { window.setTimeout(() => this.setState({ alert: { isOpen: false } }), Timeout('No file returned.')); }
        );
        return;
      }
      openFileInNewTab(blob, invoiceFileName);
    });
  }

  async populateClaimantData() {
    this.setState({ fetchingData: true });

    await FetchData(
      '/getclaimants',
      'POST',
      this.user.token,
      this.state.searchModel,
    ).then((data) => {
      this.setState({
        claimantList: data,
        loading: false,
        fetchingData: false,
      });
    });
  }

  renderClaimantTable() {
    return (
      <ClaimantTableDefault
        claimants={this.state.claimantList}
        handleClick={this.handleClick}
        handleDoubleClick={this.handleDoubleClick}
        setModal={this.setModal}
        addWorkOrder={this.addWorkOrder}
        state={this.state}
      />
    );
  }

  renderWorkOrderTable() {
    return (
      <WorkOrderTableDefault
        workOrders={this.state.jobList}
        setData={(woData, rowIndex) => this.viewWorkOrder({ data: woData }, true)}
        viewInvoice={this.viewInvoice}
        state={this.state}
      />
    );
  }

  setFetchingData(fetching) {
    console.log(fetching);
    this.setState({ fetchingData: fetching });
  }

  render() {
    let claimantContents = this.state.loading ? (
      <p>
        {' '}
        <em>Loading...</em>{' '}
      </p>
    ) : (
      this.renderClaimantTable()
    );

    let workOrderContents = this.state.loading ? (
      <p>
        {' '}
        <em>Loading...</em>{' '}
      </p>
    ) : (
      this.renderWorkOrderTable()
    );

    return (
      <div
        style={{
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          paddingTop: '12px',
        }}
      >
        {' '}
        <center>
          <Alert
            color={this.state.alert.color}
            isOpen={this.state.alert.isOpen}
          >
            {this.state.alert.message}
          </Alert>
        </center>
        <h5 id="tableLabel">Claimant</h5>
        <Row>
          <Col>
            <InputGroup
              size="sm"
              style={{ minWidth: '600px', overflow: 'hidden' }}
            >
              <Button color="btn" onClick={this.resetFields} size="sm">
                <img
                  src={AddIcon}
                  style={{ width: '16px', height: '16px' }}
                  alt="Add"
                />{' '}
                New
              </Button>
              <input
                name="Name"
                type="text"
                className="form-control form-control-text"
                value={this.state.searchModel.Name}
                onChange={this.handleSearchChange}
                placeholder="Claimant (Lastname Firstname)"
                onKeyDown={this.handleKeyDown}
              />
              <input
                name="ClmClaimNumberNoDash"
                type="text"
                className="form-control form-control-text"
                value={this.state.searchModel.ClmClaimNumberNoDash}
                onChange={this.handleSearchChange}
                placeholder="Claimant #"
                onKeyDown={this.handleKeyDown}
              />
              <input
                name="ClientAbbrv"
                type="text"
                className="form-control form-control-text"
                value={this.state.searchModel.ClientAbbrv}
                onChange={this.handleSearchChange}
                placeholder="Client Abbrv"
                onKeyDown={this.handleKeyDown}
              />
              <input
                name="Phone"
                type="text"
                className="form-control form-control-text"
                value={this.state.searchModel.Phone}
                onChange={this.handleSearchChange}
                placeholder="Phone"
                onKeyDown={this.handleKeyDown}
              />
              <input
                name="Employer"
                type="text"
                className="form-control form-control-text"
                value={this.state.searchModel.Employer}
                onChange={this.handleSearchChange}
                placeholder="Employer"
                onKeyDown={this.handleKeyDown}
              />
              <input
                name="Insured"
                type="text"
                className="form-control form-control-text"
                value={this.state.searchModel.Insured}
                onChange={this.handleSearchChange}
                placeholder="Insured"
                onKeyDown={this.handleKeyDown}
              />
            </InputGroup>
          </Col>
        </Row>
        <LoadingModal fetchingData={this.state.fetchingData} />
        {this.state.modal && (
          <ClaimantForm
            model={this.state.model}
            modal={this.state.modal}
            alert={this.state.alert}
            setModal={this.setModal}
            handleSaveEventSuccess={this.handleSaveEventSuccess}
            setFetchingData={this.setFetchingData}
          />
        )}
        {this.state.modalWorkOrder && (
          <WorkOrderForm
            model={this.state.job}
            modal={this.state.modalWorkOrder}
            alert={this.state.alert}
            setModal={this.setModalWorkOrder}
            workOrderList={[]}
            jobHistoryList={[]}
            jobInvLineList={[]}
            setNextPrevData={null}
            selectedIndex={0}
            handleSaveEventSuccess={this.handleSaveEventWorkOrderSuccess}
            setFetchingData={this.setFetchingData}
          />
        )}
        <div>{claimantContents}</div>
        <hr />
        {this.state.selectedClaimant !== null && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              height: '300px',
            }}
          >
            {workOrderContents}
          </div>
        )}
      </div>
    );
  }
}
